import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetOrg } from '@/api/sys.user';
import util from '@/libs/util.js';
export default {
  mounted: function mounted() {
    this.getOrgList();
  },
  data: function data() {
    return {
      ORG_ID: null,
      orgOptions: [],
      oldORG_ID: null
    };
  },
  methods: {
    handleSelected: function handleSelected(value) {
      var _this = this;

      // this.ORG_ID = this.oldORG_ID
      // console.log(this.ORG_ID)
      // console.log('this.orgOptions',this.orgOptions)
      this.$confirm('切换组织将会重置系统, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // util.cookies.set('ORG_CODE', this.ORG_ID)
        _this.orgOptions.forEach(function (item) {
          if (_this.ORG_ID === item.value) {
            util.cookies.set('ORG_ID', value);
            util.cookies.set('ORG_CODE', item.key);
            _this.ORG_ID = value;
          }
        });

        window.location.reload();
      }).catch(function () {// this.$message.warning('已取消')
      });
    },
    getOrgList: function getOrgList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return GetOrg();

              case 2:
                res = _context.sent;

                // console.log('组织架构列表 res', res)
                if (res.code === 0) {
                  // this.ORG_ID = res.data[0].SysOrganizeId
                  _this2.orgOptions = res.data.map(function (v) {
                    return {
                      label: v.OrganizeName,
                      value: v.SysOrganizeId,
                      key: v.OrganizeCode
                    };
                  });
                  _this2.ORG_ID = util.cookies.get('ORG_ID'); // console.log(typeof util.cookies.get('ORG_ID'));
                  // if (util.cookies.get('ORG_ID')) {
                  //   util.cookies.set('ORG_CODE', util.cookies.get('ORG_CODE'))
                  //   util.cookies.set('ORG_ID', util.cookies.get('ORG_ID'))
                  //   this.ORG_ID = util.cookies.get('ORG_ID')
                  // } else {
                  //   util.cookies.set('ORG_CODE', res.data[0].Id)
                  //   util.cookies.set('ORG_ID', res.data[0].Id)
                  //   this.ORG_ID = res.data[0].Id
                  // }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};